import * as squareStyles from "./StandardSignPostCarouselCard.square.module.scss";

import { navigate } from "gatsby";
import React from "react";
import FuzzyBorder from "../../../components/borders/FuzzyBorder";
import { Colours } from "../../../utils/colours";
import { pushToDataLayer } from "../../../utils/google";
import CurvedBorder from "../../borders/CurvedBorder";
import Button from "../../common/Button";
import ProcessedImage from "../../common/ProcessedImage/ProcessedImage";

export const StandardSignPostCarouselCard: React.FC<
	DogsTrust.SignPostCardProps
> = ({
	imgSrc,
	title,
	body,
	buttonLabel,
	buttonUrl,
	externalUrl,
	isSuccessStory,
	isRTE,
}) => {
	const Border = isSuccessStory ? FuzzyBorder : CurvedBorder;

	return (
		<div className={squareStyles.squarecardwrapper}>
			<div className={squareStyles.squarecardcomponent}>
				<div className={squareStyles.squarecardimage}>
					<ProcessedImage
						className={squareStyles.squarecardcardimg}
						src={imgSrc}
						dimensions="400x300"
						width={400}
						height={300}
						alt={title}
						onClick={() => {
							pushToDataLayer({
								event: "button_navigation",
								button_clicked: buttonLabel,
							});
							navigate(buttonUrl);
						}}
						loading={"lazy"}
					/>
					<div className={squareStyles.squarecardborderwrapper}>
						<div className={squareStyles.squarecardborder}>
							<Border rotation={0} fill={Colours.WHITE} width={"300"} />
						</div>
					</div>
				</div>

				<div className={squareStyles.squarecarddetails}>
					<div>
						<button
							type="button"
							className={squareStyles.cardtitleanchor}
							onClick={(e) => {
								e.preventDefault();
								pushToDataLayer({
									event: "button_navigation",
									button_clicked: buttonLabel,
								});
								navigate(buttonUrl);
							}}
						>
							<h2
								data-variation="hideFromJumpLinks"
								className={squareStyles.title}
							>
								{title}
							</h2>
						</button>
						<div className={squareStyles.squarecardsubtitle}>
							{isRTE ? (
								<div
									className={squareStyles.rtetext}
									// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
									dangerouslySetInnerHTML={{
										__html: body,
									}}
								/>
							) : (
								<p>{body}</p>
							)}
						</div>
					</div>
					<div className={squareStyles.buttonwrapper}>
						<Button
							variant={"tertiary"}
							size="small"
							url={buttonUrl}
							externalUrl={externalUrl}
						>
							{buttonLabel}
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default StandardSignPostCarouselCard;
